const ClientRoutes = {
  Admin: {
    main: "/admin/main",
    todos: "/admin/todos",
    avivit: "/admin/avivit",
    news: "/admin/news",
    msg: "/admin/msg",
    guests: "/admin/guests",
  },
  Producer: {
    main: "/producer/main",
    todos: "/producer/todos",
  },
  Efrat: {
    main: "/efrat/main",
  },
  Tal: {
    main: "/tal/main",
  },
  User: {
    main: "/user/main",
    tables: "/user/tables",
    todos: "/user/todos",
    instruction: "/user/instruction",
    editDetails: "/user/editDetails",
  },
  UnAuth: {
    main: "/ua/main",
    mainSBS: "/ua/mainSBS",
    mainDIY: "/ua/mainDIY",
    mainCG: "/ua/mainCG",
    mainTI: "/ua/mainTI",
    mainTipTop: "/ua/mainTipTop",
    mainDubi: "/ua/mainDubi",
    mainWD: "/ua/mainWD",
    invitation: "/n/:token",
    invitation33: "/r/:token",
    selfInvitation: "/s/:token",
    payment: "/payment",
    paymentSuccess: "/paymentsuccess",
    paymentFailed: "/paymentfailed",
  },
};

export default ClientRoutes;
